import PropTypes from 'prop-types';
import { alpha, Stack, Switch as MuiSwitch, Typography } from '@mui/material';

const styles = {
  switch: ({ palette, transitions }, isColored) => ({
    width: 54,
    height: 32,
    padding: 0,

    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: '2px',
      transitionDuration: '300ms',

      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },

      '&.Mui-checked': {
        transform: 'translateX(22px)',
        color: palette.primary.main,

        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: isColored ? alpha(palette.primary.main, 0.5) : palette.colors.lightPale,
          borderColor: isColored ? alpha(palette.primary.main, 0.1) : palette.colors.darkPale,
        },

        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
          borderColor: alpha(palette.primary.main, 0.5),
        },

        '& .MuiSwitch-thumb': {
          color: palette.primary.main,
        },
      },

      '&.Mui-disabled .MuiSwitch-thumb': {
        color: alpha(palette.primary.main, 0.5),
      },
    },

    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 28,
      height: 28,
      color: isColored ? alpha(palette.primary.main, 0.5) : palette.primary.main,
      transition: transitions.create(['color'], {
        duration: 500,
      }),
    },

    '& .MuiSwitch-track': {
      borderRadius: 32 / 2,
      backgroundColor: palette.colors.lightPale,
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: palette.colors.darkPale,
      opacity: 1,
      transition: transitions.create(['background-color', 'border-color'], {
        duration: 500,
      }),
    },
  }),
  label: ({ palette, transitions }, isActive) => ({
    color: isActive ? palette.text.primary : palette.colors.darkGrey,
    transition: transitions.create(['color'], {
      duration: 500,
    }),
  }),
};

const Switch = ({
  innerRef = null,
  value,
  onChange,
  checkedLabel = '',
  uncheckedLabel = '',
  isColored = false,
  ...props
}) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {uncheckedLabel && (
        <Typography variant="body1" sx={(theme) => styles.label(theme, !value)}>
          {uncheckedLabel}
        </Typography>
      )}

      <MuiSwitch
        disableRipple
        checked={value}
        onChange={(event, checked) => onChange(checked)}
        ref={innerRef}
        sx={(theme) => styles.switch(theme, isColored)}
        {...props}
      />

      {checkedLabel && (
        <Typography variant="body1" sx={(theme) => styles.label(theme, !!value)}>
          {checkedLabel}
        </Typography>
      )}
    </Stack>
  );
};

Switch.propTypes = {
  innerRef: PropTypes.func,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  checkedLabel: PropTypes.string,
  uncheckedLabel: PropTypes.string,
  isColored: PropTypes.bool,
};
export default Switch;
